import ListOfImageTag from "@/server/com/silkplm/rpc/plm/ListOfImageTag";
import Rpc from "@/Rpc";
import {cloneEntity} from "@/utils/Objects";

export function setImageAsMain(allTagsFromDB, image){
    let customData = image.customData;
    if(customData != null && !image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
        let customData = image.customData;
        if (!customData.imageTagList) {
            customData.imageTagList = [];
        }

        for (let tag of allTagsFromDB) {
            if (tag.name === "Main Picture")
                customData.imageTagList.push(tag);
        }
    }else if(image.customData === null) {
        customData = new ListOfImageTag();
        customData.type = customData.getRemoteClass();
        customData.imageTagList = [];

        for (let tag of allTagsFromDB) {
            if (tag.name === "Main Picture")
                customData.imageTagList.push(tag);
        }
    }

    image.starState = "star";
    image.customData = customData;
}

export function deselectImageAsMain(image){
    if(image.customData != null && image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
        image.customData.imageTagList = image.customData.imageTagList.filter(
            tag => tag.name !== "Main Picture"
        );
        image.starState = "star-outline";
    }
}

export function findMainPhoto(listOfImages) {
    if (listOfImages.length !== 0) {
        for (let image of listOfImages) {
            if (
                image.customData != null &&
                image.customData.imageTagList.find(tag => tag.name === "Main Picture")
            ) {
                image.starState = "star";
                return image;
            }
        }
    }
    return null;
}

export function setStarForMainPhoto(listOfImages) {
    if (listOfImages.length !== 0) {
        for (let image of listOfImages) {
            if (
                image.customData != null &&
                image.customData.imageTagList.find(tag => tag.name === "Main Picture")
            ) {
                image.starState = "star";
            }
        }
    }
    return null;
}

export function setImageTag(allTagsFromDB, image, tagName){
    let customData = image.customData;
    if(customData != null && !image.customData.imageTagList.find(tag => tag.name === tagName)) {
        if (!customData.imageTagList) {
            customData.imageTagList = [];
        }

        for (let tag of allTagsFromDB) {
            if (tag.name.toLowerCase() === tagName.toLowerCase())
                customData.imageTagList.push(tag);
        }
    }else if(image.customData === null) {
        customData = new ListOfImageTag();
        customData.type = customData.getRemoteClass();
        customData.imageTagList = [];

        for (let tag of allTagsFromDB) {
            if (tag.name.toLowerCase() === tagName.toLowerCase())
                customData.imageTagList.push(tag);
        }
    }
    image.customData = customData;
}

export function removeImageTag(image, tagName) {
    if (image.customData != null && Array.isArray(image.customData.imageTagList)) {
        image.customData.imageTagList = image.customData.imageTagList.filter(tag => tag.name !== tagName);
    }
    return image;
}


function generateRandomFileName(extension = 'png') {
    const timestamp = Date.now();
    const random = Math.floor(Math.random() * 100000);
    return `image_${timestamp}_${random}.${extension}`;
}

export function base64ToFile(dataUrl, fileName) {
    const [header, base64Data] = dataUrl.split(',');

    const mimeMatch = header.match(/:(.*?);/);
    if (!mimeMatch) {
        throw new Error('Nieprawidłowy format data URL');
    }
    const mime = mimeMatch[1];

    if (!fileName) {
        const extension = mime.split('/')[1];
        fileName = generateRandomFileName(extension);
    }

    const binaryString = atob(base64Data);
    const len = binaryString.length;
    const u8arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        u8arr[i] = binaryString.charCodeAt(i);
    }

    return new File([u8arr], fileName, { type: mime });
}

export function preparePlaceholder(image, allTagsFromDB){
    const placeholder = cloneEntity(image);
    placeholder.url = "";
    placeholder.data = {};
    placeholder.customData = null;
    placeholder.downloadUrl = "";
    setImageTag(allTagsFromDB, placeholder, "Generating")
    placeholder.loading = true;
    return placeholder;
}

export async function getImageFileFromUrl(url) {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], 'image.jpg', {type: blob.type});
}

export async function replacePlaceholderWithImage(newImageData, validatedField) {
    if (newImageData) {
        const index = findIndexOfPlaceholder(validatedField);
        if (index !== -1) {
            let fileObject = base64ToFile(newImageData);
            const newImageFile = await Rpc.BusinessEntities.uploadImage(fileObject, "").lock()
            if (newImageFile) {
                return [index, newImageFile];
            }
        }
    }
}

export function findIndexOfPlaceholder(validatedField) {
    return validatedField._value.imagesList.findIndex(img =>
        img.customData &&
        Array.isArray(img.customData.imageTagList) &&
        img.customData.imageTagList.some(tag => tag.name === "Generating")
    );
}
